import React from 'react'
import {
  sortAscIcon,
  sortDescIcon,
  sortIcon,
} from '../../../icons'
import './QrTagSettingList.css'

type TagWithGroup = IQrTag & { group?: IGroup }

export type QrTagSettingsSortKey = 'name' | 'description' | 'qr_code_number'
export type QrTagSettingsSortOrder = 'asc' | 'desc'

type Props = {
  qrTags: TagWithGroup[]
  loading: boolean
  error?: string | null
  onEdit: (qrTag: IQrTag) => void
  sortKey: QrTagSettingsSortKey | null
  sortOrder: QrTagSettingsSortOrder
  onSort: (key: QrTagSettingsSortKey) => void
}

const QrTagSettingList = ({
  qrTags,
  loading,
  error = null,
  onEdit,
  sortKey,
  sortOrder,
  onSort,
}: Props) => {
  const statusMessage = (() => {
    if (loading) return 'QRタグを読み込み中...'
    if (error) return error
    return 'QRタグがありません。'
  })()

  const getSortHeaderIcon = (key: QrTagSettingsSortKey) => {
    if (sortKey !== key) return sortIcon
    return sortOrder === 'asc' ? sortAscIcon : sortDescIcon
  }

  return (
    <div className="qr-tag-settings-table">
      <table className="table">
        <thead className="header">
          <tr>
            <th>
              <div
                className="title"
                style={{ cursor: 'pointer' }}
                onClick={() => onSort('name')}
                data-testid="settings-qr-tags-header-sort-name"
              >
                タグ名
                <img alt="sort" src={getSortHeaderIcon('name')} />
              </div>
            </th>
            <th>
              <div
                className="title"
                style={{ cursor: 'pointer' }}
                onClick={() => onSort('description')}
                data-testid="settings-qr-tags-header-sort-description"
              >
                説明
                <img alt="sort" src={getSortHeaderIcon('description')} />
              </div>
            </th>
            <th>
              <div
                className="title"
                style={{ cursor: 'pointer' }}
                onClick={() => onSort('qr_code_number')}
                data-testid="settings-qr-tags-header-sort-qr-code-number"
              >
                QRコード番号
                <img alt="sort" src={getSortHeaderIcon('qr_code_number')} />
              </div>
            </th>
            <th><div className="title">グループ</div></th>
            <th aria-label="操作"><div className="title" aria-hidden="true" /></th>
          </tr>
        </thead>
        <tbody className="list">
          {qrTags.length === 0 ? (
            <tr>
              <td className="list-row" colSpan={5}>{statusMessage}</td>
            </tr>
          ) : qrTags.map((qrTag) => (
            <tr key={qrTag.id} className="qr-tag-settings-table__row">
              <td className="qr-tag-settings-table__cell">
                <div className="qr-tag-settings-table__name">
                  {qrTag.name || '名称未設定'}
                </div>
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__description">
                {qrTag.description || '未設定'}
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__code">
                {qrTag.qr_code_info?.qr_code_number
                  || qrTag.qr_code_info?.digit_code
                  || '未設定'}
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__group">
                {qrTag.group?.name ?? '-'}
              </td>
              <td className="qr-tag-settings-table__cell qr-tag-settings-table__actions">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => onEdit(qrTag)}
                >
                  編集する
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default QrTagSettingList
